import "./Sidebar.css";
import { Sidebar, SubMenu, Menu, MenuItem } from "react-pro-sidebar";
import { Link } from "react-router-dom";

function SideBar() {
  return (
    <div className="sidebar-container">
      <Sidebar className="custom-sidebar">
        <main>
          <Menu>
            <SubMenu
              icon={<i className="fa-solid fa-square-h"></i>}
              label="Hologram"
            >
              <MenuItem component={<Link to="HologramDetail" />}>
                Manage Hologram
              </MenuItem>
              <MenuItem component={<Link to="ManageHologram" />}>
                Hologram Status
              </MenuItem>
            </SubMenu>

            <MenuItem
              icon={<i className="fa-sharp fa-solid fa-note-sticky"></i>}
              component={<Link to="Sticker" />}
            >
              Sticker
            </MenuItem>

            <SubMenu
              icon={<i className="fa-solid fa-book"></i>}
              label="Print Book"
            >
              <MenuItem component={<Link to="Printing" />}>
                Printing Status
              </MenuItem>
              <MenuItem component={<Link to="Manageprint" />}>
                Manage Printing
              </MenuItem>
            </SubMenu>

            <SubMenu
              icon={<i className="fa-solid fa-file-invoice"></i>}
              label="Invoice"
            >
              <MenuItem component={<Link to="Invoice" />}>
                Create Invoice
              </MenuItem>
              <MenuItem component={<Link to="Manageinvoice" />}>
                Manage Invoice
              </MenuItem>
            </SubMenu>

            <SubMenu
              icon={<i className="fa-solid fa-file-invoice"></i>}
              label="Challan"
            >
              <MenuItem
                icon={<i className="fa-solid fa-print"></i>}
                component={<Link to="CreatePrintingPress" />}
              >
                Create Printing Press
              </MenuItem>
              <MenuItem
                icon={<i className="fa-solid fa-print"></i>}
                component={<Link to="Manageprintingpress" />}
              >
                Manage Printing Press
              </MenuItem>
              <MenuItem
                icon={<i className="fa-solid fa-receipt"></i>}
                component={<Link to="DispatchChallan" />}
              >
                Create Challan
              </MenuItem>
              <MenuItem
                icon={<i className="fa-solid fa-receipt"></i>}
                component={<Link to="ManageDispatchChallan" />}
              >
                Manage Challan
              </MenuItem>
            </SubMenu>

            <SubMenu
              icon={<i className="fa-solid fa-barcode"></i>}
              label="Scan Data"
            >
              <MenuItem
                icon={<i className="fa-solid fa-truck"></i>}
                component={<Link to="Outbound" />}
              >
                Scan
              </MenuItem>
              <MenuItem
                icon={<i className="fa-solid fa-truck"></i>}
                component={<Link to="Quickhashing" />}
              >
                Scan (6th Edition)
              </MenuItem>
              <MenuItem
                icon={<i className="fa-solid fa-truck"></i>}
                component={<Link to="Managescan" />}
              >
                Manage Scan Data
              </MenuItem>
            </SubMenu>

            <MenuItem
              icon={<i className="fa-solid fa-money-check-dollar"></i>}
              component={<Link to="Payments" />}
            >
              Payments
            </MenuItem>
          </Menu>
        </main>
      </Sidebar>
    </div>
  );
}

export default SideBar;
